/**
 * Reading/Distance/Non-prescription/Progressive/Bifocal + Sunglasses —
 * inline lens type + color on one screen (GUSA-style).
 */
(function () {
  var STEP_SELECTOR = '.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)';
  var SCOPE_CLASS = 'ciw-la-sunglasses-lens-selection-step';
  var BODY_ACTIVE_CLASS = 'ciw-la-sunglasses-lens-selection-active';
  var BODY_SKIP_CLASS = 'ciw-la-sunglasses-skipping-color-step';
  var BODY_POST_CONFIRM_CLASS = 'ciw-la-sunglasses-post-confirm';
  var BODY_PACKAGE_REVEALED_CLASS = 'ciw-la-sunglasses-package-revealed';
  var BODY_PACKAGE_LAYOUT_READY_CLASS = 'ciw-la-sunglasses-package-layout-ready';
  var OUTGOING_COLOR_CARD_CLASS = 'ciw-la-sunglasses-outgoing-color-card';
  var OUTGOING_COLOR_SECTION_CLASS = 'ciw-la-sunglasses-outgoing-color-section';
  var LENS_COLOR_NAME_RE =
    /^(gray|grey|brown|g[\s.-]?15(\s*green)?|green|graphite|amber|rose|red|yellow|blue|purple|amethyst)$/i;
  var LENS_TIER_NAME_RE = /^(basic|standard|polycarbonate|premium|supreme\+?)$/i;
  var PICKED_CLASS = 'ciw-la-lens-card--picked';
  var SWATCH_PICKED_CLASS = 'ciw-la-sunglasses-color-swatch--picked';
  var SWATCHS_CONTAINER_CLASS = 'ciw-la-sunglasses-inline-colors';
  var SWATCH_ITEM_CLASS = 'ciw-la-sunglasses-color-item';
  var SWATCH_FILL_CLASS = 'ciw-la-sunglasses-color-swatch__fill';
  var SWATCH_LABEL_CLASS = 'ciw-la-sunglasses-color-label';
  var SWATCH_LABEL_VISIBLE_CLASS = 'ciw-la-sunglasses-color-label--visible';
  var TYPE_CARD_CLASS = 'ciw-la-sunglasses-type-card';
  var TYPE_MAIN_CLASS = 'ciw-la-sunglasses-type-main';
  var TYPE_DESCRIPTION_CLASS = 'ciw-la-sunglasses-type-description';
  var STEP_TITLE = 'Sunglasses lens selection';
  var DOWNSTREAM_LA_OPTION_RE =
    /lens\s*thickness|lens\s*material|^material$|choose\s*your\s*lenses|lens\s*package|lens\s*index/i;

  var boundScope = null;
  var pendingTypeWrapper = null;
  var pendingColor = '';
  var confirming = false;
  var skippingBackToSunglasses = false;
  var confirmSkipWatch = null;
  var packageRevealStableCount = 0;
  var maintainingPackage = false;
  var packageLayoutFallbackId = null;
  var scanBurstQueued = false;
  var LENS_PACKAGE_SCOPE_CLASS = 'ciw-la-lens-package-step';
  var LENS_PACKAGE_CONTENT_BODY_CLASS = 'ciw-la-lens-package-content-body';

  function normalizeLabel(text) {
    return String(text || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Desktop package cards use restoreDesktopLensPackageCard (no ready/head).
     Mobile layout adds those markers — do not change mobile reveal gating. */
  function isDesktopViewport() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function getSelectedPrescriptionTypeText() {
    var la = window.LensAdvizor;
    if (!la || !la.response || !la.response.selectedPrescriptionType) return '';

    var sel = la.response.selectedPrescriptionType;
    if (typeof sel === 'string') return normalizeLabel(sel);
    return normalizeLabel([sel.title, sel.name, sel.type, sel.handle].filter(Boolean).join(' '));
  }

  var INLINE_SUNGLASSES_USAGE_RE =
    /reading|distance|non[\s-]?prescription|fashion|plano|progressive|bifocal/i;

  function isInlineSunglassesPrescriptionFlow() {
    if (INLINE_SUNGLASSES_USAGE_RE.test(getSelectedPrescriptionTypeText())) return true;

    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return false;

    var checked = modal.querySelector(
      '.la-choose-prescription-wrapper:not(.la-render-lenses):not(.la-render-options):not(.la-render-review):not(.la-render-addons) input[type="radio"]:checked'
    );
    if (!checked) return false;

    var btn = checked.closest('.la-label-btn');
    var titleEl = btn && btn.querySelector('.la-label-title');
    return INLINE_SUNGLASSES_USAGE_RE.test(normalizeLabel(titleEl ? titleEl.textContent : ''));
  }

  function isSunglassesLensGroupSelected(la) {
    la = la || window.LensAdvizor;
    if (!la || !la.response) return false;

    if (la.response.lens && /sunglass/i.test(normalizeLabel(la.response.lens.group_title))) {
      return true;
    }

    if (!la.lensGroups || !la.response.lensGroupSelected) return false;

    var selectedKey = la.response.lensGroupSelected;
    var i;
    for (i = 0; i < la.lensGroups.length; i++) {
      var group = la.lensGroups[i];
      if (group.group_type !== selectedKey && String(group.id) !== String(selectedKey)) continue;
      return /sunglass/i.test(normalizeLabel(group.group_title || group.title || ''));
    }

    return /sunglass|tinted_polorised|tinted_polarised/i.test(String(selectedKey || ''));
  }

  function isSunglassesLensTypeTitle(title) {
    return /^(solid tint|gradient tint|polarized)$/i.test(normalizeLabel(title));
  }

  function getSunglassesLensTypeDescription(title) {
    var normalizedTitle = normalizeLabel(title).toLowerCase();
    if (normalizedTitle === 'solid tint') return 'One even shade from top to bottom.';
    if (normalizedTitle === 'gradient tint') {
      return 'Darker at the top and lighter at the bottom.';
    }
    if (normalizedTitle === 'polarized') {
      return 'Cuts glare from roads, water, and other shiny surfaces.';
    }
    return '';
  }

  function isSunglassesLensSelectionScope(scope) {
    if (!scope || !scope.classList.contains('la-render-lenses') || scope.classList.contains('x-pro')) {
      return false;
    }
    if (!isInlineSunglassesPrescriptionFlow()) return false;

    var wrappers = scope.querySelectorAll('.la-label-btn-wrapper');
    var typeCount = 0;
    var i;
    for (i = 0; i < wrappers.length; i++) {
      var titleNode = wrappers[i].querySelector('.la-label-title');
      var cardTitle = titleNode ? normalizeLabel(titleNode.textContent) : '';
      if (isSunglassesLensTypeTitle(cardTitle)) typeCount++;
    }

    return typeCount >= 2;
  }

  function getScope() {
    var scope = document.querySelector(STEP_SELECTOR);
    if (!scope || !isSunglassesLensSelectionScope(scope)) return null;
    return scope;
  }

  function isActive() {
    return !!(window.ciwLaHostApi && window.ciwLaHostApi.isEyeglass()) && !!getScope();
  }

  function getWrappers(scope) {
    scope = scope || getScope();
    if (!scope) return [];
    return Array.prototype.slice.call(scope.querySelectorAll('.la-label-btn-wrapper'));
  }

  function getCardBtn(wrapper) {
    return wrapper ? wrapper.querySelector('.la-label-btn') : null;
  }

  function getCardTitle(wrapper) {
    var btn = getCardBtn(wrapper);
    if (!btn) return '';
    var titleNode = btn.querySelector('.la-label-title');
    return normalizeLabel(titleNode ? titleNode.textContent : btn.textContent);
  }

  function getRadio(wrapper) {
    return wrapper ? wrapper.querySelector('input[type="radio"].la-tap-select') : null;
  }

  var GRADIENT_FILL_CLASS = 'ciw-la-sunglasses-color-swatch__fill--gradient';
  var LENS_SHINE_FILL_CLASS = 'ciw-la-sunglasses-color-swatch__fill--lens-shine';

  /* LensDirect Gradient PNGs (Jul 2026); brown + g15 tuned for clearer hue on 24px circles. */
  var GRADIENT_TINT_SWATCHES = {
    gray: 'linear-gradient(180deg, rgb(80, 82, 97) 0%, rgba(173, 174, 181, 0.55) 100%)',
    brown: 'linear-gradient(180deg, rgb(104, 68, 26) 0%, rgba(210, 178, 138, 0.62) 100%)',
    g15: 'linear-gradient(180deg, rgb(83, 112, 64) 0%, rgba(180, 210, 158, 0.65) 100%)',
    red: 'linear-gradient(180deg, rgb(254, 84, 108) 0%, rgba(255, 221, 226, 0.55) 100%)',
    yellow: 'linear-gradient(180deg, rgb(228, 195, 78) 0%, rgba(253, 247, 210, 0.55) 100%)',
    blue: 'linear-gradient(180deg, rgb(2, 169, 221) 0%, rgba(199, 226, 237, 0.55) 100%)',
    purple: 'linear-gradient(180deg, rgb(148, 116, 196) 0%, rgba(204, 199, 220, 0.55) 100%)',
  };

  /* LensDirect Tint + Premium Polarized solid swatch PNGs; brown + g15 match gradient tuning. */
  var SOLID_TINT_SWATCHES = {
    gray: '#817f84',
    brown: '#68441a',
    g15: '#537040',
    red: '#fe546c',
    yellow: '#e3c55a',
    blue: '#2b4a6a',
    purple: '#9474c4',
  };

  function isGradientTintLensType(typeName) {
    return normalizeLabel(typeName).toLowerCase() === 'gradient tint';
  }

  function isSolidTintLensType(typeName) {
    var normalizedType = normalizeLabel(typeName).toLowerCase();
    return normalizedType === 'solid tint' || normalizedType === 'polarized';
  }

  function getSunglassesSwatchColorKey(colorName) {
    var label = normalizeLabel(colorName).toLowerCase().split(' - ')[0];
    if (/^gr[ae]y$/i.test(label) || /^graphite$/i.test(label)) return 'gray';
    if (/^brown$/i.test(label) || /^amber$/i.test(label)) return 'brown';
    if (/^g[\s.-]?15(\s*green)?$|^green$/i.test(label)) return 'g15';
    if (/^rose$/i.test(label)) return 'red';
    if (/^yellow$/i.test(label)) return 'yellow';
    if (/^blue$/i.test(label)) return 'blue';
    if (/^purple$/i.test(label) || /^amethyst$/i.test(label)) return 'purple';
    return '';
  }

  function getGradientTintSwatchBackground(colorName) {
    var key = getSunglassesSwatchColorKey(colorName);
    return key ? GRADIENT_TINT_SWATCHES[key] : '';
  }

  function getSolidTintSwatchColor(colorName) {
    var key = getSunglassesSwatchColorKey(colorName);
    return key ? SOLID_TINT_SWATCHES[key] : '#9ca3af';
  }

  function getColorSwatchTint(colorName) {
    return getSolidTintSwatchColor(colorName);
  }

  function applySwatchFillStyle(fill, lensTypeName, colorName) {
    if (!fill) return;

    var gradientBg = isGradientTintLensType(lensTypeName)
      ? getGradientTintSwatchBackground(colorName)
      : '';

    if (gradientBg) {
      fill.classList.add(GRADIENT_FILL_CLASS);
      fill.classList.remove(LENS_SHINE_FILL_CLASS);
      fill.style.removeProperty('--ciw-la-color-swatch');
      fill.style.background = gradientBg;
      fill.style.backgroundColor = 'transparent';
      return;
    }

    fill.classList.remove(GRADIENT_FILL_CLASS);
    fill.style.removeProperty('background');
    fill.style.backgroundColor = '';
    fill.classList.toggle(LENS_SHINE_FILL_CLASS, isSolidTintLensType(lensTypeName));
    fill.style.setProperty(
      '--ciw-la-color-swatch',
      isSolidTintLensType(lensTypeName)
        ? getSolidTintSwatchColor(colorName)
        : getColorSwatchTint(colorName)
    );
  }

  function getSunglassesGroupKeys(la) {
    la = la || window.LensAdvizor;
    if (!la) return [];

    var keys = [];
    if (la.response && la.response.lensGroupSelected) {
      keys.push(String(la.response.lensGroupSelected));
    }

    if (la.lensGroups) {
      var i;
      for (i = 0; i < la.lensGroups.length; i++) {
        var group = la.lensGroups[i];
        var title = normalizeLabel(group.group_title || group.title || '');
        if (/sunglass/i.test(title)) {
          if (group.group_type) keys.push(String(group.group_type));
          if (group.id != null) keys.push(String(group.id));
        }
      }
    }

    return keys.filter(function (key, index, arr) {
      return key && arr.indexOf(key) === index;
    });
  }

  function getSunglassesLensesFromLa(la) {
    la = la || window.LensAdvizor;
    if (!la) return [];

    var groupKeys = getSunglassesGroupKeys(la);
    var lenses = [];
    var seen = {};
    var i;
    var j;
    var key;
    var bucket;

    if (la.lensesByGroups) {
      for (i = 0; i < groupKeys.length; i++) {
        key = groupKeys[i];
        bucket = la.lensesByGroups[key];
        if (!bucket || !bucket.length) continue;
        for (j = 0; j < bucket.length; j++) {
          if (!bucket[j] || seen[bucket[j].id]) continue;
          seen[bucket[j].id] = true;
          lenses.push(bucket[j]);
        }
      }
    }

    if (!lenses.length && la.lensesByGroups) {
      Object.keys(la.lensesByGroups).forEach(function (key) {
        bucket = la.lensesByGroups[key];
        if (!bucket || !bucket.length) return;
        for (j = 0; j < bucket.length; j++) {
          if (!bucket[j] || seen[bucket[j].id]) continue;
          if (!isSunglassesLensTypeTitle(bucket[j].name)) continue;
          seen[bucket[j].id] = true;
          lenses.push(bucket[j]);
        }
      });
    }

    if (!lenses.length && Array.isArray(la.lenses)) {
      for (i = 0; i < la.lenses.length; i++) {
        if (!la.lenses[i] || seen[la.lenses[i].id]) continue;
        if (/sunglass|tint|polarized/i.test(normalizeLabel(la.lenses[i].name || ''))) {
          seen[la.lenses[i].id] = true;
          lenses.push(la.lenses[i]);
        }
      }
    }

    return lenses;
  }

  function getColorsForLensTypeName(typeName) {
    var la = window.LensAdvizor;
    var lenses = getSunglassesLensesFromLa(la);
    var target = normalizeLabel(typeName).toLowerCase();
    var i;
    var lens;
    var values;

    for (i = 0; i < lenses.length; i++) {
      lens = lenses[i];
      if (normalizeLabel(lens.name).toLowerCase() !== target) continue;
      values =
        lens.options &&
        lens.options.option1 &&
        Array.isArray(lens.options.option1.values)
          ? lens.options.option1.values
          : [];
      return values.map(normalizeLabel).filter(Boolean);
    }

    if (la && la.response && la.response.lens && normalizeLabel(la.response.lens.name).toLowerCase() === target) {
      values =
        la.response.lens.options &&
        la.response.lens.options.option1 &&
        Array.isArray(la.response.lens.options.option1.values)
          ? la.response.lens.options.option1.values
          : [];
      return values.map(normalizeLabel).filter(Boolean);
    }

    return [];
  }

  function isVisibleInModal(el) {
    if (!el || el.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return el.getClientRects().length > 0;
  }

  function isLikelyLensColorCardName(name) {
    return LENS_COLOR_NAME_RE.test(normalizeLabel(name).split(' - ')[0]);
  }

  function isLikelyThicknessTierName(name) {
    return LENS_TIER_NAME_RE.test(normalizeLabel(name).split(' - ')[0]);
  }

  function countDomPackageCards(scope) {
    var tier = 0;
    var color = 0;

    getWrappers(scope).forEach(function (wrapper) {
      var title = getCardTitle(wrapper);
      if (isLikelyThicknessTierName(title)) tier++;
      else if (isLikelyLensColorCardName(title)) color++;
    });

    return { tier: tier, color: color };
  }

  function countVisiblePackageCards(scope, ignoreVisibility) {
    var visTier = 0;
    var visColor = 0;

    getWrappers(scope).forEach(function (wrapper) {
      if (!ignoreVisibility && !isVisibleInModal(wrapper)) return;
      var title = getCardTitle(wrapper);
      if (isLikelyThicknessTierName(title)) visTier++;
      else if (isLikelyLensColorCardName(title)) visColor++;
    });

    return { visTier: visTier, visColor: visColor };
  }

  function getPostConfirmOptionsScope() {
    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return null;

    var scopes = modal.querySelectorAll('.la-choose-prescription-wrapper.la-render-options');
    var i;
    for (i = 0; i < scopes.length; i++) {
      if (countDomPackageCards(scopes[i]).tier >= 2) return scopes[i];
    }

    return null;
  }

  function isOutgoingPackageHeading(text) {
    text = normalizeLabel(text);
    if (/^select\s+color$/i.test(text)) return true;
    if (/^choose\s+lens\s+package\s*:/i.test(text)) return true;
    return false;
  }

  function hideOutgoingColorSections(scope) {
    if (!scope) return;

    scope.querySelectorAll('.la-label-btn-wrapper, .la-horizontal-boxy-label-wrapper').forEach(function (wrapper) {
      var title = getCardTitle(wrapper);
      wrapper.classList.toggle(OUTGOING_COLOR_CARD_CLASS, isLikelyLensColorCardName(title));
    });

    scope.querySelectorAll('.la-prescription-wrapper, .la-option-container').forEach(function (section) {
      var wrappers = section.querySelectorAll('.la-label-btn-wrapper');
      if (!wrappers.length) {
        section.classList.remove(OUTGOING_COLOR_SECTION_CLASS);
        return;
      }

      var allColor = true;
      var i;
      for (i = 0; i < wrappers.length; i++) {
        if (!isLikelyLensColorCardName(getCardTitle(wrappers[i]))) {
          allColor = false;
          break;
        }
      }

      section.classList.toggle(OUTGOING_COLOR_SECTION_CLASS, allColor);
    });

    scope.querySelectorAll('.la-wrapper-heading, h3, h4').forEach(function (headingWrap) {
      var heading =
        headingWrap.querySelector('h3, h4, h2') ||
        (headingWrap.matches('h3, h4, h2') ? headingWrap : null);
      var text = heading ? normalizeLabel(heading.textContent) : normalizeLabel(headingWrap.textContent);
      if (!headingWrap.closest('.la-label-btn')) {
        headingWrap.classList.toggle(OUTGOING_COLOR_SECTION_CLASS, isOutgoingPackageHeading(text));
      }
    });
  }

  function clearLaOptionStore(store) {
    if (!store || typeof store !== 'object') return false;

    var cleared = false;
    Object.keys(store).forEach(function (key) {
      if (!DOWNSTREAM_LA_OPTION_RE.test(key)) return;
      delete store[key];
      cleared = true;
    });
    return cleared;
  }

  function clearStaleDownstreamLaSelections(la) {
    la = la || window.LensAdvizor;
    if (!la || !la.response || !isSunglassesLensGroupSelected(la)) return;

    var lens = la.response.lens;
    var lensName = lens && normalizeLabel(lens.name);
    var hasStaleTransitionsLens =
      !!lensName &&
      !isSunglassesLensTypeTitle(lensName) &&
      /transition|gen\s*s|xtr|photo/i.test(lensName);

    var clearedDownstream =
      clearLaOptionStore(la.customOptions) || clearLaOptionStore(la.customFieldData);

    if (!clearedDownstream && !hasStaleTransitionsLens) return;

    if (la.response.raw_options && typeof la.response.raw_options === 'object') {
      delete la.response.raw_options.option2;
      delete la.response.raw_options.option3;
    }

    if (hasStaleTransitionsLens) {
      delete la.response.lens;
      delete la.response.lensVariant;
    }
  }

  function clearTransitionsDrawerPollution() {
    if (
      window.ciwLaTransitionsDrawer &&
      typeof window.ciwLaTransitionsDrawer.clearFlowPollution === 'function'
    ) {
      window.ciwLaTransitionsDrawer.clearFlowPollution();
    }
  }

  function clearOutgoingColorMarkers(root) {
    (root || document)
      .querySelectorAll('.' + OUTGOING_COLOR_CARD_CLASS + ', .' + OUTGOING_COLOR_SECTION_CLASS)
      .forEach(function (el) {
        el.classList.remove(OUTGOING_COLOR_CARD_CLASS, OUTGOING_COLOR_SECTION_CLASS);
      });
  }

  function setPackageStepTitle(scope) {
    if (!scope) return;

    var titleEl =
      scope.querySelector('#la_prescriptionSelect_title') ||
      scope.querySelector('.la-wrapper-heading h3');
    if (!titleEl) return;

    if (/choose\s+lens\s+package/i.test(normalizeLabel(titleEl.textContent))) return;

    var lensName = '';
    if (pendingTypeWrapper) {
      lensName = getCardTitle(pendingTypeWrapper);
    }
    if (!lensName) {
      var la = window.LensAdvizor;
      if (
        la &&
        la.response &&
        la.response.lens &&
        isSunglassesLensTypeTitle(la.response.lens.name)
      ) {
        lensName = normalizeLabel(la.response.lens.name);
      }
    }
    if (!lensName) lensName = 'Solid tint';

    titleEl.textContent = 'Choose lens package for ' + lensName;
  }

  function clearPostConfirmState() {
    document.body.classList.remove(BODY_POST_CONFIRM_CLASS);
    document.body.classList.remove(BODY_PACKAGE_REVEALED_CLASS);
    document.body.classList.remove(BODY_PACKAGE_LAYOUT_READY_CLASS);
    if (packageLayoutFallbackId) {
      window.clearTimeout(packageLayoutFallbackId);
      packageLayoutFallbackId = null;
    }
    clearOutgoingColorMarkers();
  }

  /* Progressive/Bifocal + Sunglasses continues to "Choose progressive type"
     (Ultimate HD / Varilux / ZEISS), not Choose lens package. The Non-Rx
     package-reveal CSS hides every la-render-options that lacks
     ciw-la-lens-package-step — so this step looks blank. Drop the gates. */
  function isProgressiveTypeOptionsVisible() {
    var title = getModalStepTitle();
    if (/progressive\s*type/i.test(title)) return true;

    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return false;

    var scope =
      modal.querySelector(
        '.la-choose-prescription-wrapper.ciw-la-progressive-type-options-step'
      ) || modal.querySelector('.la-choose-prescription-wrapper.la-render-options');
    if (!scope || scope.hasAttribute('hidden')) return false;
    if (scope.classList.contains(LENS_PACKAGE_SCOPE_CLASS)) return false;
    if (countDomPackageCards(scope).tier >= 2) return false;

    var titles = '';
    scope.querySelectorAll('.la-label-title').forEach(function (el) {
      titles += ' ' + (el.textContent || '');
    });
    return /ultimate\s*hd|varilux|zeiss\s*smart/i.test(titles);
  }

  function releaseSunglassesGatesForProgressiveTypeStep() {
    if (
      !confirming &&
      !document.body.classList.contains(BODY_POST_CONFIRM_CLASS) &&
      !document.body.classList.contains(BODY_SKIP_CLASS) &&
      !document.body.classList.contains(BODY_PACKAGE_REVEALED_CLASS)
    ) {
      return false;
    }
    if (!isProgressiveTypeOptionsVisible()) return false;

    stopConfirmSkipWatch();
    confirming = false;
    document.body.classList.remove(BODY_SKIP_CLASS);
    document.body.classList.remove(BODY_ACTIVE_CLASS);
    clearPostConfirmState();
    pendingTypeWrapper = null;
    pendingColor = '';
    unbindScope();
    return true;
  }

  function markPackageStepRevealed() {
    if (document.body.classList.contains(BODY_PACKAGE_REVEALED_CLASS)) {
      suppressSunglassesSelectionOverlay();
      return;
    }
    document.body.classList.add(BODY_PACKAGE_REVEALED_CLASS);
    document.body.classList.remove(BODY_SKIP_CLASS);
    suppressSunglassesSelectionOverlay();
    document.dispatchEvent(new CustomEvent('ciw-la-sunglasses-package:revealed'));
  }

  function revealPackageStep(scope) {
    document.body.classList.add(BODY_POST_CONFIRM_CLASS);
    hideOutgoingColorSections(scope);
    setPackageStepTitle(scope);
    requestPackageLayoutScan();

    function tryReveal() {
      hideOutgoingColorSections(scope);
      syncPackageLayoutReadyFlag(scope);
      if (isPackageLayoutReadyForReveal(scope)) {
        markPackageStepRevealed();
        return true;
      }
      return false;
    }

    if (tryReveal()) return;

    window.requestAnimationFrame(function () {
      if (tryReveal()) return;
      [80, 200, 450].forEach(function (delay) {
        window.setTimeout(function () {
          if (document.body.classList.contains(BODY_PACKAGE_REVEALED_CLASS)) return;
          tryReveal();
        }, delay);
      });
      schedulePackageLayoutReadyFallback(scope);
    });
  }

  function clearStalePackageLayoutState() {
    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return;

    modal.querySelectorAll('.la-choose-prescription-wrapper.la-render-options').forEach(function (scope) {
      scope.classList.remove(LENS_PACKAGE_SCOPE_CLASS);
      scope.querySelectorAll('.ciw-la-lens-card--ready').forEach(function (btn) {
        btn.classList.remove('ciw-la-lens-card--ready');
      });
    });

    var contentBody = modal.querySelector('.la-prescription-modal-content-body');
    if (!contentBody) return;

    contentBody.classList.remove(LENS_PACKAGE_CONTENT_BODY_CLASS);
    contentBody.style.removeProperty('display');
    contentBody.style.removeProperty('flex-direction');
    contentBody.style.removeProperty('align-items');
  }

  function getPackageContentBody() {
    var modal = document.getElementById('lensadvizor-prescription-modal');
    return modal ? modal.querySelector('.la-prescription-modal-content-body') : null;
  }

  function getVisibleTierButtons(scope, ignoreVisibility) {
    var buttons = [];

    getWrappers(scope).forEach(function (wrapper) {
      if (!isLikelyThicknessTierName(getCardTitle(wrapper))) return;
      if (!ignoreVisibility && !isVisibleInModal(wrapper)) return;
      var btn = getCardBtn(wrapper);
      if (btn) buttons.push(btn);
    });

    return buttons;
  }

  function isPackageLayoutReady(scope) {
    if (!scope) return false;

    var tierButtons = getVisibleTierButtons(scope, confirming);
    if (tierButtons.length < 2) return false;

    if (isDesktopViewport()) return true;

    var i;
    for (i = 0; i < tierButtons.length; i++) {
      if (!tierButtons[i].classList.contains('ciw-la-lens-card--ready')) return false;
      if (!tierButtons[i].querySelector('.ciw-la-lens-card-head')) return false;
    }

    return true;
  }

  function isPackageLayoutReadyForReveal(scope) {
    if (!scope) return false;

    var tierButtons = getVisibleTierButtons(scope, true);
    if (tierButtons.length < 2) return false;

    if (isDesktopViewport()) return true;

    var i;
    for (i = 0; i < tierButtons.length; i++) {
      if (!tierButtons[i].classList.contains('ciw-la-lens-card--ready')) return false;
      if (!tierButtons[i].querySelector('.ciw-la-lens-card-head')) return false;
    }

    return true;
  }

  function syncPackageLayoutReadyFlag(scope) {
    var ready = isPackageLayoutReadyForReveal(scope);
    document.body.classList.toggle(BODY_PACKAGE_LAYOUT_READY_CLASS, ready);
    return ready;
  }

  function schedulePackageLayoutReadyFallback(scope) {
    if (packageLayoutFallbackId) return;
    packageLayoutFallbackId = window.setTimeout(function () {
      packageLayoutFallbackId = null;
      if (document.body.classList.contains(BODY_PACKAGE_LAYOUT_READY_CLASS)) return;
      scope = scope || getPostConfirmOptionsScope();
      if (!scope) return;
      if (getVisibleTierButtons(scope, true).length >= 2) {
        document.body.classList.add(BODY_PACKAGE_LAYOUT_READY_CLASS);
        markPackageStepRevealed();
      }
    }, isDesktopViewport() ? 120 : 2200);
  }

  function suppressSunglassesSelectionOverlay() {
    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return;

    modal
      .querySelectorAll(
        '.la-choose-prescription-wrapper.ciw-la-sunglasses-lens-selection-step, .la-choose-prescription-wrapper.la-render-lenses:not(.x-pro):not(.ciw-la-transitions-drawer-step)'
      )
      .forEach(function (el) {
        if (el.classList.contains(LENS_PACKAGE_SCOPE_CLASS)) return;
        if (el.classList.contains('ciw-la-lens-thickness-step')) return;
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
        el.style.setProperty('pointer-events', 'none', 'important');
      });
  }

  function unsuppressSunglassesSelectionScope(scope) {
    scope = scope || document.querySelector(STEP_SELECTOR);
    if (!scope) return;

    scope.removeAttribute('hidden');
    scope.removeAttribute('aria-hidden');
    scope.style.removeProperty('pointer-events');
    document.body.classList.remove(BODY_SKIP_CLASS);
  }

  function requestPackageLayoutScan() {
    var modal = document.getElementById('lensadvizor-prescription-modal');
    document.dispatchEvent(
      new CustomEvent('ciw-la-lens-package:scan-now', {
        detail: { root: modal || document }
      })
    );
  }

  function isPostConfirmStable(scope) {
    scope = scope || getPostConfirmOptionsScope();
    if (!scope || !isPackageLayoutReady(scope)) return false;

    hideOutgoingColorSections(scope);

    var dom = countDomPackageCards(scope);
    var visible = countVisiblePackageCards(scope, confirming);
    var tierCount = confirming ? dom.tier : visible.visTier;
    var colorCount = confirming ? dom.color : visible.visColor;

    if (tierCount < 2) return false;
    if (colorCount === 0) return true;

    return (
      (confirming || visible.visColor === 0) &&
      scope.querySelectorAll('.' + OUTGOING_COLOR_CARD_CLASS).length > 0
    );
  }

  function stopConfirmSkipWatch() {
    if (!confirmSkipWatch) return;
    window.clearInterval(confirmSkipWatch);
    confirmSkipWatch = null;
  }

  function finishConfirmTransition(scope) {
    stopConfirmSkipWatch();
    packageRevealStableCount = 0;

    scope = scope || getPostConfirmOptionsScope();

    pendingTypeWrapper = null;
    pendingColor = '';
    unbindScope();
    document.body.classList.remove(BODY_ACTIVE_CLASS);
    confirming = false;

    /* Progressive type is the real next step — do not enter package-reveal CSS. */
    if (!scope && isProgressiveTypeOptionsVisible()) {
      document.body.classList.remove(BODY_SKIP_CLASS);
      clearPostConfirmState();
      document.dispatchEvent(new CustomEvent('ciw-la-sunglasses-lens-selection:confirmed'));
      return;
    }

    document.body.classList.add(BODY_POST_CONFIRM_CLASS);

    if (scope) {
      hideOutgoingColorSections(scope);
      setPackageStepTitle(scope);
      scope.classList.add(LENS_PACKAGE_SCOPE_CLASS);
      revealPackageStep(scope);
    } else {
      markPackageStepRevealed();
    }

    document.dispatchEvent(new CustomEvent('ciw-la-sunglasses-lens-selection:confirmed'));
  }

  function syncPostConfirmTransition() {
    if (!confirming) return;

    if (releaseSunglassesGatesForProgressiveTypeStep()) return;

    if (isSunglassesIntermediateColorStep()) {
      setSkipHide(true);
      return;
    }

    var scope = getPostConfirmOptionsScope();
    if (!scope) {
      if (isProgressiveTypeOptionsVisible()) {
        releaseSunglassesGatesForProgressiveTypeStep();
        return;
      }
      setSkipHide(true);
      return;
    }

    requestPackageLayoutScan();
    hideOutgoingColorSections(scope);
    document.body.classList.add(BODY_POST_CONFIRM_CLASS);
    setSkipHide(true);

    if (isPostConfirmStable(scope)) {
      finishConfirmTransition(scope);
    }
  }

  function isPackageStepSettled() {
    return (
      document.body.classList.contains(BODY_PACKAGE_REVEALED_CLASS) &&
      document.body.classList.contains(BODY_PACKAGE_LAYOUT_READY_CLASS)
    );
  }

  function maintainPostConfirmPackageStep() {
    if (
      !document.body.classList.contains(BODY_POST_CONFIRM_CLASS) &&
      !document.body.classList.contains(BODY_PACKAGE_REVEALED_CLASS)
    ) {
      return;
    }

    if (maintainingPackage) return;
    maintainingPackage = true;

    try {
      var scope = getPostConfirmOptionsScope();
      if (
        !scope ||
        (!confirming &&
          !document.body.classList.contains(BODY_SKIP_CLASS) &&
          !isVisibleInModal(scope))
      ) {
        if (
          confirming ||
          document.body.classList.contains(BODY_SKIP_CLASS) ||
          document.body.classList.contains(BODY_PACKAGE_REVEALED_CLASS)
        ) {
          return;
        }
        clearPostConfirmState();
        return;
      }

      document.body.classList.add(BODY_POST_CONFIRM_CLASS);
      hideOutgoingColorSections(scope);

      if (isPackageStepSettled()) {
        setPackageStepTitle(scope);
        return;
      }

      setPackageStepTitle(scope);
      requestPackageLayoutScan();
      syncPackageLayoutReadyFlag(scope);
      if (isPackageLayoutReadyForReveal(scope)) {
        markPackageStepRevealed();
      } else {
        schedulePackageLayoutReadyFallback(scope);
      }
    } finally {
      maintainingPackage = false;
    }
  }

  function startConfirmSkipWatch() {
    stopConfirmSkipWatch();
    packageRevealStableCount = 0;
    setSkipHide(true);
    document.body.classList.add(BODY_POST_CONFIRM_CLASS);

    var start = Date.now();
    syncPostConfirmTransition();
    confirmSkipWatch = window.setInterval(function () {
      if (Date.now() - start > 4000) {
        finishConfirmTransition(getPostConfirmOptionsScope());
        return;
      }
      syncPostConfirmTransition();
    }, 80);

    [150, 400, 850, 1600, 2400].forEach(function (delay) {
      window.setTimeout(syncPostConfirmTransition, delay);
    });
  }

  function shouldUseSkipHide() {
    return !document.body.classList.contains(BODY_PACKAGE_REVEALED_CLASS);
  }

  function setSkipHide(active) {
    if (active && !shouldUseSkipHide()) return;
    document.body.classList.toggle(BODY_SKIP_CLASS, !!active);
  }

  function isSunglassesIntermediateColorStep() {
    if (!isInlineSunglassesPrescriptionFlow() || !isSunglassesLensGroupSelected()) return false;

    if (
      document.body.classList.contains(BODY_POST_CONFIRM_CLASS) ||
      document.body.classList.contains(BODY_PACKAGE_REVEALED_CLASS) ||
      confirming
    ) {
      return false;
    }

    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return false;

    var modalTitle = getModalStepTitle();
    if (isSunglassesDownstreamStepTitle(modalTitle)) return false;

    var optionsScope = modal.querySelector('.la-choose-prescription-wrapper.la-render-options');
    if (!optionsScope || !isVisibleInModal(optionsScope)) return false;

    var titleEl =
      optionsScope.querySelector('#la_prescriptionSelect_title') ||
      optionsScope.querySelector('.la-wrapper-heading h3');
    var title = normalizeLabel(titleEl ? titleEl.textContent : '');
    return (
      (/select.*color/i.test(title) || /select options for/i.test(title)) &&
      /(?:solid tint|gradient tint|polarized)/i.test(title)
    );
  }

  function clearBackSkipHideIfDone() {
    if (getScope()) {
      document.body.classList.remove(BODY_SKIP_CLASS);
      return true;
    }
    if (!isSunglassesIntermediateColorStep()) {
      document.body.classList.remove(BODY_SKIP_CLASS);
      return true;
    }
    return false;
  }

  function trySkipIntermediateColorStepOnBack() {
    if (skippingBackToSunglasses || confirming) return false;
    if (!isSunglassesIntermediateColorStep()) return false;

    var back = document.querySelector(
      '#lensadvizor-prescription-modal .la-steeper-back:not(:disabled), .la-steeper-back:not(:disabled)'
    );
    if (!back) return false;

    skippingBackToSunglasses = true;
    setSkipHide(true);
    back.click();

    window.setTimeout(function () {
      skippingBackToSunglasses = false;
      clearBackSkipHideIfDone();
      scheduleScan();
    }, 280);

    return true;
  }

  function restoreSelectionFromLa(scope) {
    if (!scope || (pendingTypeWrapper && pendingColor)) return;

    var la = window.LensAdvizor;
    if (!la || !la.response) return;

    var lens = la.response.lens;
    if (!lens || !isSunglassesLensTypeTitle(lens.name)) return;

    var wrappers = getWrappers(scope);
    var i;
    var typeWrapper = null;
    for (i = 0; i < wrappers.length; i++) {
      if (
        normalizeLabel(getCardTitle(wrappers[i])).toLowerCase() ===
        normalizeLabel(lens.name).toLowerCase()
      ) {
        typeWrapper = wrappers[i];
        break;
      }
    }
    if (!typeWrapper) return;

    var colorValue = '';
    if (la.response.lensVariant && la.response.lensVariant.option1) {
      colorValue = normalizeLabel(la.response.lensVariant.option1);
    } else if (la.response.raw_options && la.response.raw_options.option1) {
      colorValue = normalizeLabel(la.response.raw_options.option1);
    }

    pendingTypeWrapper = typeWrapper;
    if (colorValue) pendingColor = colorValue;
  }

  function isOnActiveSunglassesPackageStep() {
    if (
      !document.body.classList.contains(BODY_POST_CONFIRM_CLASS) &&
      !document.body.classList.contains(BODY_PACKAGE_REVEALED_CLASS)
    ) {
      return false;
    }

    var title = getModalStepTitle();
    return /choose\s+lens\s+package|select options for/i.test(title);
  }

  function isInlineSunglassesSelectionVisible() {
    return document.querySelectorAll('.ciw-la-sunglasses-color-swatch').length >= 4;
  }

  function restoreInlineSelectionAfterPackageBack() {
    var scope = getScope();
    if (!scope) return false;

    unsuppressSunglassesSelectionScope(scope);
    scope.classList.add(SCOPE_CLASS);
    activateStep(scope);
    return true;
  }

  function handleBackFromSunglassesPackageStep() {
    var progressiveApi = window.ciwLaProgressivePackageContinue;
    if (progressiveApi && typeof progressiveApi.suspend === 'function') {
      progressiveApi.suspend();
    }
    if (progressiveApi && typeof progressiveApi.clearOutlines === 'function') {
      progressiveApi.clearOutlines();
    }

    clearPostConfirmState();
    clearStalePackageLayoutState();

    var nativeBack = document.querySelector(
      '#lensadvizor-prescription-modal .la-steeper-back:not(:disabled)'
    );
    if (!nativeBack) return;

    nativeBack.click();

    function finishBackChain(attempt) {
      if (isInlineSunglassesSelectionVisible()) {
        restoreInlineSelectionAfterPackageBack();
        return;
      }

      if (isSunglassesIntermediateColorStep()) {
        trySkipIntermediateColorStepOnBack();
        window.setTimeout(function () {
          if (isInlineSunglassesSelectionVisible()) {
            restoreInlineSelectionAfterPackageBack();
            return;
          }
          finishBackChain(attempt + 1);
        }, 220);
        return;
      }

      if (attempt >= 2) {
        restoreInlineSelectionAfterPackageBack();
        return;
      }

      var back = document.querySelector(
        '#lensadvizor-prescription-modal .la-steeper-back:not(:disabled)'
      );
      if (back) back.click();
      window.setTimeout(function () {
        finishBackChain(attempt + 1);
      }, 220);
    }

    window.setTimeout(function () {
      finishBackChain(0);
    }, 180);
  }

  function scheduleBackSkipChecks() {
    if (isSunglassesDownstreamStepTitle(getModalStepTitle())) return;
    [0, 100, 300].forEach(function (delay) {
      window.setTimeout(trySkipIntermediateColorStepOnBack, delay);
    });
  }

  function scheduleBackSkipHide() {
    if (isSunglassesDownstreamStepTitle(getModalStepTitle())) return;
    [0, 160].forEach(function (delay) {
      window.setTimeout(function () {
        if (!isInlineSunglassesPrescriptionFlow() || !isSunglassesLensGroupSelected()) return;
        if (isSunglassesIntermediateColorStep()) {
          setSkipHide(true);
          trySkipIntermediateColorStepOnBack();
        }
      }, delay);
    });
  }

  function formatPriceText(raw) {
    var cleaned = normalizeLabel(raw).replace(/^\(|\)$/g, '').trim();
    var text = cleaned.replace(/^\+/, '').trim();
    if (!text || /^selected$/i.test(text)) return '';
    if (/^free$/i.test(text) || /^[$]?0(?:\.00)?$/i.test(text)) return '(FREE)';

    var amountMatch = text.match(/\$?\s*([\d,]+(?:\.\d{1,2})?)/);
    if (amountMatch) {
      var amount = amountMatch[1].replace(/,/g, '').replace(/\.00$/, '');
      if (!amount || /^0+$/.test(amount)) return '(FREE)';
      return '(+$' + amount + ')';
    }

    var price = cleaned.replace(/\.00\b/g, '');
    if (!/^\$/.test(price) && !/^\+/.test(price)) price = '+$' + price;
    else if (/^\$/.test(price)) price = '+' + price;
    return '(' + price + ')';
  }

  function getPriceTextForWrapper(wrapper) {
    var btn = getCardBtn(wrapper);
    if (!btn) return '';

    var priceInline = btn.querySelector('.ciw-la-lens-card-price-inline');
    if (priceInline && normalizeLabel(priceInline.textContent)) {
      return formatPriceText(priceInline.textContent);
    }

    var price = btn.querySelector('.la-label-price');
    if (!price) return '';

    var clone = price.cloneNode(true);
    var compare = clone.querySelector('.la-compare-at-price');
    if (compare) compare.remove();
    return formatPriceText(clone.textContent || '');
  }

  function ensurePriceInline(wrapper, btn, titleRow) {
    if (!btn || !titleRow) return;

    var price = btn.querySelector('.la-label-price');
    var priceInline = btn.querySelector('.ciw-la-lens-card-price-inline');
    var priceText = getPriceTextForWrapper(wrapper);

    if (!priceInline) {
      priceInline = document.createElement('span');
      priceInline.className = 'ciw-la-lens-card-price-inline';
      titleRow.appendChild(priceInline);
    } else if (priceInline.parentNode !== titleRow) {
      titleRow.appendChild(priceInline);
    }

    if (priceText) {
      priceInline.textContent = priceText;
    } else if (priceInline.textContent) {
      priceInline.textContent = formatPriceText(priceInline.textContent);
    }

    if (price) {
      price.classList.add('ciw-la-lens-card-price-hidden');
    }
  }

  function ensureCardStructure(wrapper) {
    var btn = getCardBtn(wrapper);
    if (!btn) return null;

    btn.classList.add(TYPE_CARD_CLASS);
    /* Progressive-type layout can mis-tag this step and leave an empty title-row
       as a head sibling, which un-pins swatches from the right edge. */
    btn.classList.remove('ciw-la-lens-card--progressive-type', 'ciw-la-lens-card--has-icon');

    var head = btn.querySelector('.ciw-la-lens-card-head');
    if (!head) {
      head = document.createElement('div');
      head.className = 'ciw-la-lens-card-head';
      btn.insertBefore(head, btn.firstChild);
    }

    var typeMain = head.querySelector('.' + TYPE_MAIN_CLASS);
    if (!typeMain) {
      typeMain = document.createElement('div');
      typeMain.className = TYPE_MAIN_CLASS;
      head.insertBefore(typeMain, head.firstChild);
    }

    var titleRow = typeMain.querySelector('.ciw-la-lens-card-title-row');
    if (!titleRow) {
      titleRow = document.createElement('div');
      titleRow.className = 'ciw-la-lens-card-title-row';
      typeMain.appendChild(titleRow);
    }

    var title = btn.querySelector('.la-label-title');
    if (title && title.parentNode !== titleRow) {
      titleRow.appendChild(title);
    }

    ensurePriceInline(wrapper, btn, titleRow);

    var descriptionText = getSunglassesLensTypeDescription(getCardTitle(wrapper));
    var description = typeMain.querySelector('.' + TYPE_DESCRIPTION_CLASS);
    if (!description) {
      description = document.createElement('p');
      description.className = TYPE_DESCRIPTION_CLASS;
      typeMain.appendChild(description);
    }
    if (description.textContent !== descriptionText) {
      description.textContent = descriptionText;
    }

    /* Drop orphan title-rows progressive-type layout may have appended on head. */
    Array.prototype.slice.call(head.children).forEach(function (child) {
      if (
        child.classList.contains('ciw-la-lens-card-title-row') &&
        child !== titleRow &&
        !child.querySelector('.la-label-title')
      ) {
        child.remove();
      }
    });

    head.style.setProperty('padding-bottom', '0', 'important');
    btn.style.setProperty('justify-content', 'center', 'important');

    return {
      btn: btn,
      head: head,
      typeMain: typeMain,
      titleRow: titleRow,
      description: description
    };
  }

  function clearInlineSwatches(scope) {
    scope = scope || boundScope;
    if (!scope) return;
    scope.querySelectorAll('.' + SWATCHS_CONTAINER_CLASS).forEach(function (el) {
      el.remove();
    });
    scope.querySelectorAll('.' + TYPE_CARD_CLASS).forEach(function (btn) {
      btn.classList.remove(TYPE_CARD_CLASS);
    });
  }

  function renderInlineSwatches(wrapper) {
    if (!wrapper || !isSunglassesLensTypeTitle(getCardTitle(wrapper))) return;

    var structure = ensureCardStructure(wrapper);
    if (!structure) return;

    var head = structure.head;
    var lensTypeName = getCardTitle(wrapper);
    var colors = getColorsForLensTypeName(lensTypeName);
    if (!colors.length) return;

    var container = head.querySelector('.' + SWATCHS_CONTAINER_CLASS);
    if (!container) {
      container = document.createElement('div');
      container.className = SWATCHS_CONTAINER_CLASS;
      container.setAttribute('role', 'group');
      head.appendChild(container);
    }

    container.setAttribute('aria-label', 'Lens color for ' + getCardTitle(wrapper));

    var isActiveType = wrapper === pendingTypeWrapper;
    var pickedColor = isActiveType ? pendingColor : '';
    var existingItems = container.querySelectorAll('.' + SWATCH_ITEM_CLASS);

    colors.forEach(function (color, index) {
      var item = existingItems[index];
      var swatch;
      var label;
      var fill;

      if (!item) {
        item = document.createElement('div');
        item.className = SWATCH_ITEM_CLASS;

        swatch = document.createElement('span');
        swatch.className = 'ciw-la-sunglasses-color-swatch';
        swatch.setAttribute('tabindex', '0');

        fill = document.createElement('span');
        fill.className = SWATCH_FILL_CLASS;
        fill.setAttribute('aria-hidden', 'true');
        swatch.appendChild(fill);

        label = document.createElement('span');
        label.className = SWATCH_LABEL_CLASS;

        item.appendChild(swatch);
        item.appendChild(label);
        container.appendChild(item);
      } else {
        swatch = item.querySelector('.ciw-la-sunglasses-color-swatch');
        label = item.querySelector('.' + SWATCH_LABEL_CLASS);
        fill = swatch && swatch.querySelector('.' + SWATCH_FILL_CLASS);
      }

      if (!swatch || !label) return;

      swatch.setAttribute('aria-label', color);
      swatch.dataset.ciwSunglassesColor = color;
      applySwatchFillStyle(fill, lensTypeName, color);

      var isPicked = isActiveType && pickedColor === color;
      swatch.classList.toggle(SWATCH_PICKED_CLASS, isPicked);
      swatch.setAttribute('aria-selected', isPicked ? 'true' : 'false');
      syncSwatchLabel(label, color, isPicked);
    });

    while (container.children.length > colors.length) {
      container.lastChild.remove();
    }
  }

  function getSwatchDisplayLabel(colorName) {
    var label = normalizeLabel(colorName);
    if (/^g[\s.-]?15(\s*green)?$/i.test(label)) return 'G15';
    return label;
  }

  function syncSwatchLabel(label, color, isPicked) {
    if (!label) return;
    label.textContent = getSwatchDisplayLabel(color);
    label.classList.toggle(SWATCH_LABEL_VISIBLE_CLASS, isPicked);
    label.setAttribute('aria-hidden', isPicked ? 'false' : 'true');
  }

  function syncPriceDisplay(scope) {
    scope = scope || boundScope;
    if (!scope) return;

    getWrappers(scope).forEach(function (wrapper) {
      if (!isSunglassesLensTypeTitle(getCardTitle(wrapper))) return;
      var btn = getCardBtn(wrapper);
      if (!btn) return;
      var titleRow = btn.querySelector('.ciw-la-lens-card-title-row');
      if (titleRow) ensurePriceInline(wrapper, btn, titleRow);
    });
  }

  function updateSwatchSelection(scope) {
    scope = scope || boundScope;
    if (!scope) return;

    getWrappers(scope).forEach(function (wrapper) {
      if (!isSunglassesLensTypeTitle(getCardTitle(wrapper))) return;
      ensureCardStructure(wrapper);
    });

    getWrappers(scope).forEach(function (wrapper) {
      var btn = getCardBtn(wrapper);
      if (!btn) return;
      btn.classList.toggle(PICKED_CLASS, !!pendingTypeWrapper && wrapper === pendingTypeWrapper);

      if (!isSunglassesLensTypeTitle(getCardTitle(wrapper))) return;

      var container = btn.querySelector('.' + SWATCHS_CONTAINER_CLASS);
      if (!container) {
        renderInlineSwatches(wrapper);
        return;
      }

      var isActiveType = wrapper === pendingTypeWrapper;
      var pickedColor = isActiveType ? pendingColor : '';

      container.querySelectorAll('.' + SWATCH_ITEM_CLASS).forEach(function (item) {
        var swatch = item.querySelector('.ciw-la-sunglasses-color-swatch');
        var label = item.querySelector('.' + SWATCH_LABEL_CLASS);
        if (!swatch || !label) return;

        var color = normalizeLabel(
          swatch.dataset.ciwSunglassesColor || swatch.getAttribute('aria-label') || ''
        );
        var isPicked = isActiveType && pickedColor === color;
        swatch.classList.toggle(SWATCH_PICKED_CLASS, isPicked);
        swatch.setAttribute('aria-selected', isPicked ? 'true' : 'false');
        syncSwatchLabel(label, color, isPicked);
      });
    });
  }

  function refreshInlineSwatches(scope) {
    scope = scope || boundScope;
    if (!scope) return;

    getWrappers(scope).forEach(function (wrapper) {
      if (!isSunglassesLensTypeTitle(getCardTitle(wrapper))) return;
      renderInlineSwatches(wrapper);
    });

    getWrappers(scope).forEach(function (item) {
      var btn = getCardBtn(item);
      if (!btn) return;
      btn.classList.toggle(PICKED_CLASS, !!pendingTypeWrapper && item === pendingTypeWrapper);
    });
  }

  function getWrapperFromSwatch(swatch) {
    if (!swatch || !swatch.closest) return null;
    var btn = swatch.closest('.la-label-btn');
    if (!btn) return null;
    return btn.closest('.la-label-btn-wrapper');
  }

  function setTypeAndColor(wrapper, color) {
    var scope = boundScope || getScope();
    if (!scope || !wrapper) return;

    var normalizedColor = normalizeLabel(color);
    var colors = getColorsForLensTypeName(getCardTitle(wrapper));
    if (colors.indexOf(normalizedColor) === -1) return;
    if (pendingTypeWrapper === wrapper && pendingColor === normalizedColor) return;

    pendingTypeWrapper = wrapper;
    pendingColor = normalizedColor;
    updateSwatchSelection(scope);
    document.dispatchEvent(new CustomEvent('ciw-la-sunglasses-lens-selection:changed'));
  }

  function setTypePicked(wrapper) {
    var scope = boundScope || getScope();
    if (!scope) return;
    if (pendingTypeWrapper === wrapper) return;

    clearStaleDownstreamLaSelections();

    if (pendingTypeWrapper !== wrapper) {
      pendingColor = '';
    }
    pendingTypeWrapper = wrapper || null;
    updateSwatchSelection(scope);
    document.dispatchEvent(new CustomEvent('ciw-la-sunglasses-lens-selection:changed'));
  }

  function setColorPicked(color, wrapper) {
    var normalizedColor = normalizeLabel(color);
    if (wrapper) {
      setTypeAndColor(wrapper, normalizedColor);
      return;
    }
    if (pendingColor === normalizedColor) return;
    pendingColor = normalizedColor;
    updateSwatchSelection(boundScope);
    document.dispatchEvent(new CustomEvent('ciw-la-sunglasses-lens-selection:changed'));
  }

  function isInteractiveTarget(target) {
    return !!(
      target &&
      target.closest &&
      (target.closest('[data-la-tooltip], .tooltip-span, .la-tooltip, .la-help-icon') ||
        target.closest('.' + SWATCHS_CONTAINER_CLASS))
    );
  }

  function getWrapperFromEventTarget(target) {
    if (!target || !target.closest) return null;
    var btn = target.closest('.la-label-btn');
    if (!btn) return null;
    return btn.closest('.la-label-btn-wrapper');
  }

  function onStepPointerDown(event) {
    if (!isActive() || confirming) return;

    if (event.target.closest && event.target.closest('input.la-tap-select')) return;

    var swatch = event.target.closest && event.target.closest('.ciw-la-sunglasses-color-swatch');
    if (swatch) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      var swatchWrapper = getWrapperFromSwatch(swatch);
      setColorPicked(
        swatch.dataset.ciwSunglassesColor || swatch.getAttribute('aria-label') || '',
        swatchWrapper
      );
      return;
    }

    if (isInteractiveTarget(event.target)) return;

    var scope = boundScope;
    var wrapper = getWrapperFromEventTarget(event.target);
    if (!wrapper || !scope || !scope.contains(wrapper)) return;
    if (!isSunglassesLensTypeTitle(getCardTitle(wrapper))) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    setTypePicked(wrapper);
  }

  function onStepClickCapture(event) {
    if (!isActive() || confirming) return;

    var scope = boundScope;
    var radio = event.target.closest && event.target.closest('input.la-tap-select');
    if (radio && scope && scope.contains(radio)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      setTypePicked(radio.closest('.la-label-btn-wrapper'));
    }
  }

  function escapeAttrValue(value) {
    return String(value || '')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"');
  }

  function getColorSubmitForm() {
    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return null;
    return modal.querySelector('form.la-prescription-form, form#la-prescription-form, form');
  }

  function submitColorChoice(radio, la) {
    if (!radio || !la) return false;

    if (typeof la.handleSingleOptionChange === 'function') {
      la.handleSingleOptionChange({ target: radio });
      return true;
    }

    if (typeof la.handleOptionChange === 'function') {
      la.handleOptionChange({ target: radio, type: 'click' });
      return true;
    }

    return false;
  }

  function findColorRadioForValue(colorValue) {
    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return null;

    var target = normalizeLabel(colorValue).toLowerCase();
    var wrappers = modal.querySelectorAll('.la-choose-prescription-wrapper.la-render-options .la-label-btn-wrapper');
    var i;
    var title;
    var radio;

    for (i = 0; i < wrappers.length; i++) {
      title = normalizeLabel(getCardTitle(wrappers[i])).toLowerCase();
      if (title !== target) continue;
      radio = getRadio(wrappers[i]);
      if (radio) return radio;
    }

    var form = getColorSubmitForm();
    if (!form) return null;

    var inputs = form.querySelectorAll('input[type="radio"].la-tap-select');
    for (i = 0; i < inputs.length; i++) {
      if (normalizeLabel(inputs[i].value).toLowerCase() === target) return inputs[i];
      var parentTitle = inputs[i].closest('.la-label-btn');
      if (parentTitle) {
        title = normalizeLabel(parentTitle.textContent).toLowerCase();
        if (title === target) return inputs[i];
      }
    }

    return null;
  }

  function waitForColorRadio(colorValue, attempt, callback) {
    var radio = findColorRadioForValue(colorValue);
    if (radio) {
      callback(radio);
      return;
    }
    if (attempt >= 30) {
      callback(null);
      return;
    }
    window.setTimeout(function () {
      waitForColorRadio(colorValue, attempt + 1, callback);
    }, 80);
  }

  function setStepTitle(scope) {
    if (!scope) return;
    var titleEl =
      scope.querySelector('#la_prescriptionSelect_title') ||
      scope.querySelector('.la-wrapper-heading h3');
    if (titleEl && normalizeLabel(titleEl.textContent) !== STEP_TITLE) {
      titleEl.textContent = STEP_TITLE;
    }
  }

  function confirmSelection() {
    if (!isActive() || confirming || !pendingTypeWrapper || !pendingColor) return;

    var typeRadio = getRadio(pendingTypeWrapper);
    var la = window.LensAdvizor;
    if (!typeRadio || !la || typeof la.handleLensChange !== 'function') return;

    clearStaleDownstreamLaSelections(la);
    clearTransitionsDrawerPollution();

    confirming = true;
    packageRevealStableCount = 0;
    clearStalePackageLayoutState();
    setSkipHide(true);

    getWrappers().forEach(function (wrapper) {
      var input = getRadio(wrapper);
      if (input) input.checked = wrapper === pendingTypeWrapper;
    });

    try {
      la.handleLensChange({ target: typeRadio });
    } catch (err) {
      confirming = false;
      document.body.classList.remove(BODY_SKIP_CLASS);
      return;
    }

    waitForColorRadio(pendingColor, 0, function (colorRadio) {
      if (colorRadio) {
        colorRadio.checked = true;
        submitColorChoice(colorRadio, la);
      }

      startConfirmSkipWatch();
    });
  }


  function bindScope(scope) {
    if (!scope || boundScope === scope) return;
    unbindScope();
    boundScope = scope;
    scope.classList.add(SCOPE_CLASS);
    scope.addEventListener('pointerdown', onStepPointerDown, true);
    scope.addEventListener('click', onStepClickCapture, true);
    setStepTitle(scope);
    refreshInlineSwatches(scope);
  }

  function unbindScope() {
    if (!boundScope) return;
    boundScope.classList.remove(SCOPE_CLASS);
    boundScope.removeEventListener('pointerdown', onStepPointerDown, true);
    boundScope.removeEventListener('click', onStepClickCapture, true);
    clearInlineSwatches(boundScope);
    boundScope = null;
  }

  function needsInlineSwatchRefresh(scope) {
    scope = scope || boundScope;
    if (!scope) return false;

    var wrappers = getWrappers(scope);
    var i;
    for (i = 0; i < wrappers.length; i++) {
      if (!isSunglassesLensTypeTitle(getCardTitle(wrappers[i]))) continue;
      var btn = getCardBtn(wrappers[i]);
      if (!btn || !btn.querySelector('.' + SWATCHS_CONTAINER_CLASS)) return true;
    }
    return false;
  }

  function activateStep(scope) {
    scope = scope || getScope();
    if (!scope) return;

    clearTransitionsDrawerPollution();
    clearStaleDownstreamLaSelections();
    clearPostConfirmState();
    unsuppressSunglassesSelectionScope(scope);
    scope.classList.add(SCOPE_CLASS);
    restoreSelectionFromLa(scope);

    document.body.classList.add(BODY_ACTIVE_CLASS);
    bindScope(scope);

    if (pendingTypeWrapper && !scope.contains(pendingTypeWrapper)) {
      pendingTypeWrapper = null;
      pendingColor = '';
    }

    if (needsInlineSwatchRefresh(scope)) {
      refreshInlineSwatches(scope);
    } else {
      syncPriceDisplay(scope);
      updateSwatchSelection(scope);
    }

    window.setTimeout(function () {
      document.dispatchEvent(new CustomEvent('ciw-la-sunglasses-lens-selection:changed'));
      document.dispatchEvent(new CustomEvent('ciw-la-lens-package:continue-sync'));
    }, 0);

    [80, 200, 450, 900].forEach(function (delay) {
      window.setTimeout(function () {
        if (!boundScope) return;
        unsuppressSunglassesSelectionScope(boundScope);
        syncPriceDisplay(boundScope);
        updateSwatchSelection(boundScope);
      }, delay);
    });
  }

  function deactivateStep() {
    stopConfirmSkipWatch();
    document.body.classList.remove(BODY_ACTIVE_CLASS);
    document.body.classList.remove(BODY_SKIP_CLASS);
    document.body.classList.remove(BODY_POST_CONFIRM_CLASS);
    document.body.classList.remove(BODY_PACKAGE_REVEALED_CLASS);
    clearOutgoingColorMarkers();
    pendingTypeWrapper = null;
    pendingColor = '';
    confirming = false;
    packageRevealStableCount = 0;
    unbindScope();
  }

  function getModalStepTitle() {
    var titleEl = document.querySelector(
      '#lensadvizor-prescription-modal #la_prescriptionSelect_title, #lensadvizor-prescription-modal .la-wrapper-heading h3'
    );
    return normalizeLabel(titleEl ? titleEl.textContent : '');
  }

  function isSunglassesDownstreamStepTitle(title) {
    return /choose\s+lens\s+package|available\s+upgrade|review your selection/i.test(title);
  }

  function isSunglassesPackageFlowActive() {
    return (
      document.body.classList.contains(BODY_POST_CONFIRM_CLASS) ||
      document.body.classList.contains(BODY_PACKAGE_REVEALED_CLASS) ||
      confirming
    );
  }

  function shouldHandleSunglassesDownstreamStep(title) {
    if (!isSunglassesDownstreamStepTitle(title)) return false;
    /* LA reuses "Choose lens package" on the Solid tint type picker — only treat
       package title as downstream once our post-confirm flow is active. */
    if (/choose\s+lens\s+package/i.test(title) && !isSunglassesPackageFlowActive()) {
      return false;
    }
    return true;
  }

  function scan() {
    if (!window.ciwLaHostApi || !window.ciwLaHostApi.isEyeglass()) {
      deactivateStep();
      return;
    }

    if (releaseSunglassesGatesForProgressiveTypeStep()) {
      return;
    }

    if (confirming) {
      syncPostConfirmTransition();
      return;
    }

    var stepTitle = getModalStepTitle();
    if (/available\s+upgrade|review your selection/i.test(stepTitle)) {
      /* Stale post-confirm/package-revealed flags make the footer think we are
         still on the sunglasses package step — that hides Add to cart on Review. */
      document.body.classList.remove(BODY_POST_CONFIRM_CLASS);
      document.body.classList.remove(BODY_PACKAGE_REVEALED_CLASS);
      document.body.classList.remove(BODY_PACKAGE_LAYOUT_READY_CLASS);
      return;
    }

    if (/progressive\s*type/i.test(stepTitle)) {
      return;
    }

    /* After progressive type, re-arm package flags so package Continue can bridge
       Available Upgrades (Solid tint omits add_ons from LA). Progressive clears
       these gates on the type step; re-adding classes alone does NOT re-bind
       package-continue (revealed event already fired earlier) — re-dispatch. */
    if (
      /choose\s+lens\s+package/i.test(stepTitle) &&
      isInlineSunglassesPrescriptionFlow() &&
      isSunglassesLensGroupSelected()
    ) {
      document.body.classList.add(BODY_POST_CONFIRM_CLASS);
      document.body.classList.add(BODY_PACKAGE_REVEALED_CLASS);
      document.body.classList.add(BODY_PACKAGE_LAYOUT_READY_CLASS);
      document.body.classList.remove(BODY_SKIP_CLASS);
      document.body.classList.remove(BODY_ACTIVE_CLASS);
      var pkgScope = document.querySelector(
        '.la-choose-prescription-wrapper.la-render-options'
      );
      if (pkgScope) pkgScope.classList.add(LENS_PACKAGE_SCOPE_CLASS);
      var pkgContinue = window.ciwLaProgressivePackageContinue;
      if (!(pkgContinue && typeof pkgContinue.isActive === 'function' && pkgContinue.isActive())) {
        document.dispatchEvent(new CustomEvent('ciw-la-sunglasses-package:revealed'));
      }
    }

    /* Back from progressive type / package can leave skip-hide or suppress on.
       If this is the sunglasses tint step, force it visible before anything else. */
    if (/sunglass/i.test(stepTitle) || document.querySelector('.' + SCOPE_CLASS)) {
      var earlyScope = getScope();
      if (earlyScope) unsuppressSunglassesSelectionScope(earlyScope);
    }

    if (shouldHandleSunglassesDownstreamStep(stepTitle)) {
      if (isSunglassesPackageFlowActive()) {
        if (isPackageStepSettled()) return;
        maintainPostConfirmPackageStep();
        return;
      }
      deactivateStep();
      return;
    }

    maintainPostConfirmPackageStep();

    if (isSunglassesIntermediateColorStep()) {
      setSkipHide(true);
      if (trySkipIntermediateColorStepOnBack()) return;
      return;
    }

    if (trySkipIntermediateColorStepOnBack()) return;

    var scope = getScope();
    if (!scope) {
      if (document.body.classList.contains(BODY_POST_CONFIRM_CLASS)) return;
      deactivateStep();
      return;
    }

    scope.classList.add(SCOPE_CLASS);
    activateStep(scope);
  }

  function scheduleScan() {
    scan();
    if (scanBurstQueued) return;
    scanBurstQueued = true;
    window.requestAnimationFrame(function () {
      scanBurstQueued = false;
      scan();
    });
  }

  window.ciwLaSunglassesLensSelection = {
    isActive: function () {
      return document.body.classList.contains(BODY_ACTIVE_CLASS);
    },
    hasTypeSelection: function () {
      return !!pendingTypeWrapper;
    },
    hasColorSelection: function () {
      return !!pendingColor;
    },
    isContinueEnabled: function () {
      return !!(pendingTypeWrapper && pendingColor && !confirming);
    },
    isFooterContinueReady: function () {
      return !confirming;
    },
    alertIfMissingColor: function () {
      if (pendingColor) return true;
      if (window.ciwLaConfirmDialog && typeof window.ciwLaConfirmDialog.show === 'function') {
        window.ciwLaConfirmDialog.show({
          title: 'Please select color',
          text: 'Choose a lens color before you continue.',
          primaryLabel: 'OK',
          hideSecondary: true
        });
      } else {
        window.alert('Please select color');
      }
      return false;
    },
    confirm: confirmSelection,
    getStepTitle: function () {
      return STEP_TITLE;
    }
  };

  document.addEventListener('ciw-la-sunglasses-lens-selection:changed', function () {
    window.setTimeout(function () {
      document.dispatchEvent(new CustomEvent('ciw-la-lens-package:continue-sync'));
    }, 0);
  });

  var EVENTS = [
    'LensAdvizor:lens:rendered',
    'LensAdvizor:lensOptions:rendered',
    'LensAdvizor:selectLensModal:open',
    'LensAdvizor:prescriptionTypes:rendered',
    'ciw-la-lens-package:selection-changed'
  ];

  EVENTS.forEach(function (eventName) {
    document.addEventListener(eventName, scheduleScan);
  });

  document.addEventListener('ciw-la-lens-package:scan-now', function () {
    if (maintainingPackage || isPackageStepSettled()) return;
    var scope = getPostConfirmOptionsScope();
    if (!scope) return;
    syncPackageLayoutReadyFlag(scope);
    if (isPackageLayoutReadyForReveal(scope)) {
      markPackageStepRevealed();
    }
  });

  document.addEventListener('DOMContentLoaded', scheduleScan);
  document.addEventListener('LensAdvizor:selectLensModal:close', deactivateStep);

  document.addEventListener(
    'click',
    function (event) {
      var back =
        event.target.closest &&
        event.target.closest('.ciw-la-gusa-back-btn, .la-steeper-back');
      if (!back || back.disabled) return;
      if (!isInlineSunglassesPrescriptionFlow() || !isSunglassesLensGroupSelected()) return;

      if (isOnActiveSunglassesPackageStep()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        handleBackFromSunglassesPackageStep();
        return;
      }

      /* Only skip-hide for LA's intermediate color step. Unconditional skip-hide
         from progressive type back blanks the Sunglasses lens selection step
         (CSS hides all la-render-lenses while the class is on). */
      if (isSunglassesIntermediateColorStep()) {
        setSkipHide(true);
      }
      scheduleBackSkipChecks();
      scheduleBackSkipHide();
    },
    true
  );

  var modal = document.getElementById('lensadvizor-prescription-modal');
  if (modal) {
    new MutationObserver(scheduleScan).observe(modal, {
      childList: true,
      subtree: true
    });
  }
})();
